import { PlanPickerApi } from '../../../API';
import { apiConfig } from '../../../utils/apiConfig';

export function usePlanPickerApi(): PlanPickerApi {
  return new PlanPickerApi(apiConfig);
}
